// import { Avatar, Box, Divider, Grid, Typography } from '@mui/material'
// import React, { useEffect } from 'react'

// import { useDispatch, useSelector } from 'react-redux';
// import actions from '../../../ReduxStore/actions';
// import { adminUrl } from '../../../constants';


// const EventsSideBar = () => {

//     const dispatch = useDispatch();
//     const sessionUserId = sessionStorage.getItem("userId");
//     const { getUserById } = useSelector(state => state?.getUserById);


//     const { EventGetAll } = useSelector(state => state?.EventGetAll);

//     useEffect(() => {
//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: `getAllEvents`,
//             };
//             await dispatch(actions.EVENTGETALL(data1));
//         };
//         fetchData();
//     }, [dispatch, sessionUserId]);



//     // EventGetAll


//     const cygnusaEvents = [
//         {
//             heading: "Tech Fest: Innovators Ignite",
//             date: "05/04/2023 - 30/04/2023",
//             content: "Join us for a day of creativity and innovation at the annual Tech Fest, featuring coding competitions, workshops, and expert talks! 🚀"
//         },
//         {
//             heading: "Cultural Carnival: Fusion Fiesta",
//             date: "24/05/2023 - 24/05/2023",
//             content: "Celebrate diversity with music, dance, and art at our vibrant Cultural Carnival. Unleash your talent and enjoy the magic of unity! 🎭🎶"
//         },
//         {
//             heading: "Sports Extravaganza: Champions Unite",
//             date: "01/06/2023 - 01/06/2023",
//             content: "Gear up for adrenaline-pumping action at the Sports Extravaganza. Compete, cheer, and make memories on the field! 🏅⚽"
//         },
//     ]




//     return (

//         <Grid
//             // container spacing={2}
//             sx={{
//                 // backgroundColor: "rgb(245, 245, 245)",
//                 backgroundColor: "white",

//                 minHeight: "50vh",
//                 p: 2,
//                 // pt: 3,
//                 // px: 5,
//                 width: "100%",
//                 // pb: 3
//             }}>


//             <Grid
//                 // item size={{ md: 3, xs: 12, sm: 12 }} 
//                 sx={{
//                     // backgroundColor: "white",
//                     borderRadius: "10px",
//                     // display:"flex",
//                     // justifyContent:"center"
//                     // p: 3

//                 }}>

//                 <Typography variant="subtitle1" sx={{ fontSize: "18px", color: "black", fontWeight: "600", mb: 1 }}>
//                     Cygnusa Events
//                 </Typography>
//                 <Divider />
//                 {EventGetAll?.data?.length > 0 ? (
//                     <>
//                         {EventGetAll?.data?.map((event, index) => (
//                             <Box key={event.event_id} sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
//                                 <Typography sx={{ color: "black", fontSize: "18px", fontWeight: 700, mb: 0.5 }}>
//                                     {event.event_title}
//                                 </Typography>

//                                 <Typography sx={{ color: "gray", fontSize: "14px", mb: 1 }}>
//                                     {event.campus_name}
//                                 </Typography>

//                                 <Typography sx={{ fontSize: "14px", color: "black" }}>
//                                     From: {event.from_date} &nbsp;&nbsp; To: {event.to_date}
//                                 </Typography>

//                                 <Typography variant='body1' sx={{ mt: 1.5, color: "black" }}>
//                                     {event.requirements}
//                                 </Typography>

//                                 {event.attach_files?.length > 0 && (
//                                     <Box sx={{ mt: 2 }}>
//                                         <Typography sx={{ fontWeight: 600, mb: 1 }}>Attachments:</Typography>
//                                         <Grid container spacing={2}>
//                                             {event.attach_files.map((file, i) => (
//                                                 <Grid item key={i}>
//                                                     {file.fileType === "image" && (
//                                                         <img
//                                                             src={`${adminUrl}${file.fileUrl}`}
//                                                             alt={file.fileName}
//                                                             style={{ width: 120, borderRadius: 8 }}
//                                                         />
//                                                     )}

//                                                     {file.fileType === "video" && (
//                                                         <video width="200" controls>
//                                                             <source src={`/${file.fileUrl}`} type="video/mp4" />
//                                                             Your browser does not support the video tag.
//                                                         </video>
//                                                     )}

//                                                     {file.fileType === "pdf" && (
//                                                         <a
//                                                             href={`/${file.fileUrl}`}
//                                                             target="_blank"
//                                                             rel="noopener noreferrer"
//                                                             style={{ textDecoration: "none", color: "#1976d2" }}
//                                                         >
//                                                             📄 {file.fileName}
//                                                         </a>
//                                                     )}
//                                                 </Grid>
//                                             ))}
//                                         </Grid>
//                                     </Box>
//                                 )}
//                             </Box>
//                         ))}
//                     </>
//                 ) : (
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             minHeight: '40vh', // or adjust as needed
//                             width: '100%',
//                         }}
//                     >
//                         <Typography variant='subtitle1'>
//                             No events post yet!
//                         </Typography>
//                     </Box>
//                 )}
//             </Grid>

//         </Grid>

//     )
// }

// export default EventsSideBar

import {
    Avatar,
    Box,
    Divider,
    Grid,
    Typography,
    Dialog,
    DialogContent,
    IconButton,
    Badge
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { adminUrl } from '../../../constants';
import CloseIcon from '@mui/icons-material/Close';

const EventsSideBar = () => {
    const dispatch = useDispatch();
    const sessionUserId = sessionStorage.getItem('userId');
    const { EventGetAll } = useSelector((state) => state?.EventGetAll);

    const [openModal, setOpenModal] = useState(false);
    const [selectedAttachments, setSelectedAttachments] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: 'get',
                apiName: `getAllEvents`,
            };
            await dispatch(actions.EVENTGETALL(data1));
        };
        fetchData();
    }, [dispatch, sessionUserId]);

    const handleAttachmentClick = (attachments) => {
        setSelectedAttachments(attachments);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedAttachments([]);
    };

    return (
        <Grid sx={{ backgroundColor: 'white', minHeight: '50vh', p: 2, width: '100%' }}>
            <Grid sx={{ borderRadius: '10px' }}>
                <Typography variant="subtitle1" sx={{ fontSize: '18px', color: 'black', fontWeight: 600, mb: 1 }}>
                Events
                </Typography>
                <Divider />
                {EventGetAll?.data?.length > 0 ? (
                    <>
                        {EventGetAll.data.map((event) => (
                            <Box key={event.event_id} sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2,mt:1 }}>
                                <Typography  variant="subtitle1" sx={{ color: 'black', fontSize: '18px',  mb: 0.5 }}>
                                    {event.event_title}
                                </Typography>

                                <Typography sx={{ color: 'gray', fontSize: '14px', mb: 1 }}>
                                    {event.campus_name}
                                </Typography>

                                <Typography sx={{ fontSize: '14px', color: 'black' }}>
                                    From: {event.from_date} &nbsp;&nbsp; To: {event.to_date}
                                </Typography>

                                <Typography variant="body1" sx={{ mt: 1.5, color: 'black' }}>
                                    {event.requirements}
                                </Typography>

                                {event.attach_files?.length > 0 && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography sx={{ fontWeight: 600, mb: 1,color:"black" }}>Attachments:</Typography>
                                        <Grid 
                                        // container spacing={2}
                                        >
                                            <Grid size={{xs:12}} item onClick={() => handleAttachmentClick(event.attach_files)} sx={{ cursor: 'pointer' }}>
                                                <Badge badgeContent={event.attach_files.length} color="primary">
                                                    {event.attach_files[0]?.fileType === 'image' && (
                                                        <img
                                                            src={`${adminUrl}${event.attach_files[0].fileUrl}`}
                                                            alt={event.attach_files[0].fileName}
                                                            style={{ width: "100%", borderRadius: 8 }}
                                                        />
                                                    )}
                                                    {event.attach_files[0]?.fileType === 'video' && (
                                                        <video width="100%" style={{ borderRadius: 8 }} controls>
                                                            <source src={`${adminUrl}${event.attach_files[0].fileUrl}`} type="video/mp4" />
                                                        </video>
                                                    )}
                                                    {event.attach_files[0]?.fileType === 'pdf' && (
                                                        <>
                                                            <Box
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: 2,
                                                                    width: "100%",
                                                                    height: 80,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    backgroundColor: '#f9f9f9',
                                                                }}
                                                            >
                                                                <Typography>📄 PDF</Typography>
                                                            </Box>
                                                            <a
                                                                href={`${adminUrl}${event.attach_files[0].fileUrl}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'block',
                                                                    padding: 8,
                                                                    backgroundColor: '#f1f1f1',
                                                                    borderRadius: 8,
                                                                    textAlign: 'center',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                📄 {event.attach_files[0].fileName}
                                                            </a>
                                                        </>
                                                    )}
                                                </Badge>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}
                            </Box>
                        ))}
                    </>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '40vh',
                            width: '100%',
                        }}
                    >
                        <Typography variant="subtitle1">No events posted yet!</Typography>
                    </Box>
                )}
            </Grid>

            {/* Modal */}
            <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
                    <Typography variant="h6">Attachments</Typography>
                    <IconButton onClick={handleCloseModal}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {selectedAttachments.map((file, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                {file.fileType === 'image' && (
                                    <img
                                        src={`${adminUrl}${file.fileUrl}`}
                                        alt={file.fileName}
                                        style={{ width: '100%', borderRadius: 8 }}
                                    />
                                )}
                                {file.fileType === 'video' && (
                                    <video width="100%" controls style={{ borderRadius: 8 }}>
                                        <source src={`${adminUrl}${file.fileUrl}`} type="video/mp4" />
                                    </video>
                                )}
                                {file.fileType === 'pdf' && (
                                    <a
                                        href={`${adminUrl}${file.fileUrl}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            display: 'block',
                                            padding: 8,
                                            backgroundColor: '#f1f1f1',
                                            borderRadius: 8,
                                            textAlign: 'center',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        📄 {file.fileName}
                                    </a>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
            </Dialog>
        </Grid>
    );
};

export default EventsSideBar;
